module.exports = __webpack_public_path__ + "static/candles-a2f8c6a15a45fb8dcf0cf1fbb63ce43f.png";